module.exports = __webpack_public_path__ + "img/whatsapp-button.68e9c95.svg";